<template>
  <v-container class="pa-0 offers">
    <div v-if="getMyOfferCount === 0">
      Je hebt op dit moment geen aangeboden aanvragen op ZorgSpot. Aanvragen
      bied je aan via de Cedinzorg applicatie omgeving. Bij een formulier kun je
      de aanvraag aanbieden.<br /><br />
      <v-btn
        class="no-border-shadow no-margin btn-blue full-width-login"
        color="success"
        @click.stop="$router.push({ name: 'home' })"
      >
        Startpagina &rsaquo;
      </v-btn>
    </div>

    <div v-if="getMyOfferCount > 0">
      <div class="padding-15-no-bottom background-white">
        <h1>Mijn aanbod {{ currentOffer + 1 }} / {{ getMyOfferCount }}</h1>
        <img src="/img/swipe.png" class="swipe-icon" />
        <v-progress-linear
          v-model="progress"
          height="15"
          class="rounded-progress"
          color="cedinzorg-red-accent"
        ></v-progress-linear>
      </div>

      <OfferTabs v-model="currentOffer" :offers="myOffers">
        <template v-slot:buttons>
          <v-btn
            color="success"
            class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
            dark
            @click.stop="showReactions = true"
            >Bekijk reacties (Ja {{ availableReactionsCount }}, Nee
            {{ unavailableReactionsCount }})
          </v-btn>
          <br /><br />
          <v-btn
            color="error"
            class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
            dark
            @click.stop="cancelOffer"
            >Intrekken
          </v-btn>
        </template>
      </OfferTabs>

      <!---------- Reactions dialog -------------->
      <v-dialog
        v-model="showReactions"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark class="no-border-shadow cedinzorg-lbue">
            <v-btn icon dark @click="showReactions = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Reacties ({{ reactionsCount }})</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card
                  v-for="reaction in getReactions(currentOffer)"
                  :key="reaction.id"
                  class="mb-4"
                >
                  <v-card-title>
                    <div>
                      <div class="headline">{{ reaction.user.name }}</div>
                      <div>{{ reaction.user.email }}</div>
                      <div>
                        <a :href="`tel:${reaction.user.phone}`">{{
                          reaction.user.phone
                        }}</a>
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <dl>
                      <dt><strong>Beschikbaar</strong></dt>
                      <dd>{{ reaction.is_available ? "Ja" : "Nee" }}</dd>
                    </dl>
                    <br v-if="reaction.is_available" />
                    <dl v-if="reaction.is_available">
                      <dt><strong>Kan beginnen op</strong></dt>
                      <dd>{{ reaction.start_date }}</dd>
                      <dt><strong>Beschikbaarheid</strong></dt>
                      <dd>{{ reaction.availability }}</dd>
                    </dl>
                    <br />
                    <dl v-if="reaction.notes">
                      <dt><strong>Toelichting</strong></dt>
                      <dd>{{ reaction.notes }}</dd>
                    </dl>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      v-if="offerStatus === 1 && reaction.is_available"
                      color="success"
                      class="no-border-shadow no-margin no-capitalized btn-blue full-width-login"
                      @click.stop="assignOffer(reaction)"
                      dark
                      >Toewijzen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import OfferTabs from "../components/OfferTabs";

export default {
  components: { OfferTabs },
  data() {
    return {
      showReactions: false
    };
  },
  created() {
    this.fetchMyOffers();
  },
  watch: {
    $route: "fetchMyOffers",
    currentOffer: function() {
      console.log("current changed to ", this.currentOffer);
    }
  },
  computed: {
    ...mapGetters("offer", [
      "getMyOffer",
      "getMyOfferCount",
      "getReactions",
      "getReactionsByAvailability"
    ]),
    ...mapState("offer", ["myOffers"]),
    ...mapState("user", ["user"]),
    currentOffer: {
      get() {
        console.log("currentOffer.get");
        return this.$store.state.offer.currentMyOffer;
      },
      set(value) {
        console.log("currentOffer.set");
        this.$store.commit("offer/SET_CURRENT_MY_OFFER", value);
      }
    },
    hasNext: function() {
      return this.currentOffer + 1 < this.getMyOfferCount;
    },
    hasPrev: function() {
      return this.currentOffer > 0;
    },
    progress: function() {
      return Math.round(((this.currentOffer + 1) / this.getMyOfferCount) * 100);
    },
    reactionsCount: function() {
      return this.getReactions(this.currentOffer).length;
    },
    availableReactionsCount: function() {
      return this.getReactionsByAvailability(this.currentOffer, true).length;
    },
    unavailableReactionsCount: function() {
      return this.getReactionsByAvailability(this.currentOffer, false).length;
    },
    offerStatus: function() {
      return this.getMyOffer(this.currentOffer).status;
    }
  },
  methods: {
    fetchMyOffers(reset = false) {
      this.$store.dispatch("offer/fetchMine", reset).catch(() => {
        let notification = {
          type: "error",
          message: "Er ging iets fout!"
        };
        this.$store.dispatch("notification/add", notification);
      });
    },
    cancelOffer() {
      if (confirm("Weet je zeker dat je deze aanbieding wilt intrekken?")) {
        const offerId = this.myOffers[this.currentOffer].id;
        this.$store
          .dispatch("offer/cancelOffer", offerId)
          .then(() => {
            this.$store.dispatch("notification/add", {
              type: "success",
              message: "De aanbieding is ingetrokken"
            });
            this.showReactions = false;
          })
          .catch(() => {
            let notification = {
              type: "error",
              message: "Er ging iets fout!"
            };
            this.$store.dispatch("notification/add", notification);
          });
      }
    },
    assignOffer(reaction) {
      if (
        confirm(
          "Weet je zeker dat je deze aanbieding in ZorgSpot wilt toewijzen aan deze behandelaar?"
        )
      ) {
        this.$store
          .dispatch("offer/confirm", reaction)
          .then(() => {
            this.$store.dispatch("notification/add", {
              type: "success",
              message: "De aanbieding is toegewezen"
            });
            this.fetchMyOffers();
          })
          .catch(() => {
            let notification = {
              type: "error",
              message: "Er ging iets fout!"
            };
            this.$store.dispatch("notification/add", notification);
          });
      }
    }
  }
};
</script>

<style scoped>
/*.v-tabs__bar {*/
/*  display: none !important;*/
/*}*/
</style>
